import { memo } from 'react'
import { Collapse, ListItem, ListItemButton, ListItemIcon, ListItemText, Tooltip } from '@mui/material'
import { listItemButtonSx, listItemIconSx } from './sidebar-styles'

export const SidebarMenuItem = memo(({ item, layoutExpanded, buildUrl, handleClick, isSelected }) => {
  return (
    <ListItem disablePadding>
      <Tooltip title={item.text} placement="right" disableHoverListener={layoutExpanded}>
        <ListItemButton
          component="a"
          href={buildUrl(item.path, item.requiresFarm)}
          selected={isSelected}
          onClick={(e) => handleClick(e, item.path, item.requiresFarm)}
          sx={listItemButtonSx}
        >
          <ListItemIcon sx={listItemIconSx}>
            {item.icon}
          </ListItemIcon>
          <Collapse orientation="horizontal" in={layoutExpanded} unmountOnExit>
            <ListItemText primary={item.text} sx={{ whiteSpace: 'nowrap', my: 0 }} />
          </Collapse>
        </ListItemButton>
      </Tooltip>
    </ListItem>
  )
})
